<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh"><span class="epub-b">CONTENTS</span></p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/ded#ded">Dedication</a></p>
<p class="toc-bot"><a href="#/xhtml/ack#ack">Acknowledgments</a></p>
<p class="toc"><a href="#/xhtml/chapter1#ch1">1. Premier</a></p>
<p class="toc"><a href="#/xhtml/chapter2#ch2">2. Childhood</a></p>
<p class="toc"><a href="#/xhtml/chapter3#ch3">3. Soldier</a></p>
<p class="toc"><a href="#/xhtml/chapter4#ch4">4. Pilot</a></p>
<p class="toc"><span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">5. Wing Commander</span></p>
<p class="toc"><span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">6. Coup d’État</span></p>
<p class="toc"><span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">7. Young Turks</span></p>
<p class="toc"><span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">8. Prime Minister</span></p>
<p class="toc"><span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">9. Corruption</span></p>
<p class="toc"><span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">10. Crisis</span></p>
<p class="toc"><span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">11. High Noon</span></p>
<p class="toc"><span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">12. Elections</span></p>
<p class="toc"><span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">13. Tet</span></p>
<p class="toc"><span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">14. Diplomacy</span></p>
<p class="toc"><span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">15. Debacle</span></p>
<p class="toc"><span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">16. Exile</span></p>
<p class="toc"><span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">17. Fortune-Teller</span></p>
<p class="toc-bot"><span href="#/xhtml/epilogue#epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span href="#/xhtml/copyright#crp" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?8838cda0